<template>
  <div v-if="show" class="modal fade show d-block" tabindex="-1" role="dialog" aria-labelledby="resetPasswordModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="resetPasswordModalLabel">Reset Password</h5>
          <button type="button" class="btn-close" @click="$emit('close')" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12 mb-3">
              <div class="form-group">
                <label for="" class="mb-0 pb-0">{{selectedUser.names}}</label>
                <p><small>The new password will be sent to <b>{{getFirstName(selectedUser.names)}}'s</b> phone number <b>+{{selectedUser.phoneNumber}}</b></small></p>
              </div>
            </div>

            <div v-if="getRight('CREATE PASSWORD')" class="form-group">
              <label for="">Password<strong class="text-danger">*</strong></label>
              <div>
                <input v-model="password"
                       type="text"
                       maxlength="4"
                       class="form-control"
                       placeholder="Enter Password"
                       @input="password = password.replace(/[^0-9]/g, '')">
                <p style="color: red">Please enter password (Number characters only).</p>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="handleReset" class="btn btn-danger w-100" title="Click to reset">Reset</button>
        </div>
      </div>
    </div>
  </div>
  <div v-if="show" class="modal-backdrop fade show"></div>
</template>

<script>
import {getRight} from "@/api";

export default {
  name: "ResetPasswordModal",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    selectedUser: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      password: ''
    }
  },
  watch: {
    show(newVal) {
      if (!newVal) {
        this.password = '';
      }
    }
  },
  methods: {
    getRight(type) {
      return getRight(type);
    },

    getFirstName(fullName) {
      if (!fullName) return '';
      const firstName = fullName.split(" ")[0];
      return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    },

    handleReset() {

      const passwordData = {
        names: this.selectedUser.names,
        email: this.selectedUser.email,
        phoneNumber: this.selectedUser.phoneNumber,
        category: this.selectedUser.category,
        idNo: this.selectedUser.idNo,
        zone: this.selectedUser.zone,
        subCountyID: this.selectedUser.subCountyID,
        subCountyName: this.selectedUser.subCountyName,
        wardID: this.selectedUser.wardID,
        wardName: this.selectedUser.wardName,
        id: this.selectedUser.id,
        password: this.password
      };

      this.$emit('reset', passwordData);
      this.password = '';
    }
  }
}
</script>